var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-8 mx-auto"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',[_vm._v("Add Transactions")])])]),_c('div',{staticClass:"card theme-card shadow-card"},[_c('div',{staticClass:"card-body"})])])
}]

export { render, staticRenderFns }